export default __webpack_public_path__ + "static/media/error.03bf63fe.gif";